import { pick } from "lodash";
import RenderTimelineContent from "./RenderTimelineContent";

const EMRList = ({ emr }) => {
  const sectionOrder = [
    "pet_details",
    "basic_checkup",
    "body_condition_score",
    "dental_score",
    "subjective_history",
    "physical_examinations",
    "assessment",
    "prognosis",
    "diagnosis",
    "tentative_diagnosis",
    "definitive_diagnosis",
    "general_appearance",
    "appetite",
    "lymph_nodes",
    "cmm",
    "ears",
    "paws",
    "body",
    "skin",
    "lab_test_and_diagnostics",
    "lab_test_recommended",
    "deworming_meds_treatments",
    "treatments",
    "medicines",
    "food_and_diet",
    "medical_instructions",
    "follow_up",
    "next_steps",
  ];

  const filteredSectionOrder =
    ["User Medicine Prescriptions", "Lab Report"].includes(emr?.emr_type)
      ?sectionOrder.filter((section) => section !== "basic_checkup")
      : sectionOrder;

  const sortedEMRSections = Object.keys(pick(emr, filteredSectionOrder));
  // "Refer to other doctor/clinic" lives in top-level service_referrals and renders under next_steps
  if (emr?.service_referrals?.length && !sortedEMRSections.includes("next_steps")) {
    sortedEMRSections.push("next_steps");
  }

  return (
    <div className="pl-8 md:pl-12 lg:pl-12">
      {sortedEMRSections.map((key) => (
        <RenderTimelineContent key={key} emr={emr} emrSectionKey={key} />
      ))}

      {/* attachments */}
      {emr?.attachments?.length > 0 && (
        <div className="mt-6">
          <p className="font-semibold text-theme-xs">Other Attachments</p>
          <div className="flex flex-wrap gap-3 mt-3">
            {emr?.attachments?.map((image, index) => (
              <img
                key={index}
                src={image}
                onClick={() => window.open(image, "_blank")}
                className="w-16 h-16 object-cover rounded-md mr-2 cursor-pointer"
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EMRList;
